<template>
  <div>
    <el-card shadow="never">
      <slot />
      <div class="filter-list">
        <div
          v-for="item in options"
          :key="item.value"
          class="filter-item_wrapper"
          :class="{ activate: item.value === value }"
        >
          <div class="filter-item_divided" v-if="item.divided" />
          <div class="filter-item" @click="change(item)">
            <div class="d-flex align-items-center">
              <span v-if="item.icon" class="filter-item_icon">
                <i :class="item.icon" />
              </span>
              <span class="filter-item_label">{{ item.label }}</span>
            </div>
            <div
              class="filter-item_badge"
              :class="item.type ? `filter-item_badge_${item.type}` : ''"
            >
              <span>{{ item.badge || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: { value: { type: String, default: '' } },
  data() {
    return { total: {} }
  },
  computed: {
    options() {
      return [
        {
          label: this.$l('table_filter_label_todo') || '待办',
          badge: this.total.todo,
          type: 'info',
          icon: 'el-icon-alarm-clock',
          value: 'N',
        },
        {
          label: this.$l('table_filter_label_inProcess') || '进行中',
          badge: this.total.inProcess,
          type: 'warning',
          icon: 'el-icon-refresh',
          value: 'P',
        },
        {
          label: this.$l('table_filter_label_timeout') || '已超时',
          badge: this.total.timeout,
          type: 'danger',
          icon: 'el-icon-bell',
          value: 'timeout',
        },
        {
          label: this.$l('table_filter_label_completed') || '已完成',
          badge: this.total.completed,
          type: 'success',
          icon: 'el-icon-document-checked',
          value: 'Y',
        },
        {
          label: this.$l('table_filter_label_all') || '全部任务',
          badge: this.total.all,
          type: 'info',
          icon: 'el-icon-s-order',
          value: '',
        },
        {
          label: this.$l('table_filter_label_canceled') || '已取消',
          badge: this.total.canceled,
          type: 'info',
          icon: 'el-icon-delete',
          value: 'D',
        },
        {
          label: this.$l('table_filter_label_schedule') || '我安排的任务',
          badge: this.total.schedule,
          type: 'primary',
          icon: 'el-icon-tickets',
          value: 'schedule',
          divided: true,
        },
        {
          label: this.$l('table_filter_label_related') || '和我相关的任务',
          badge: this.total.related,
          type: 'secondary',
          icon: 'el-icon-user',
          value: 'related',
        },
        {
          label: this.$l('table_filter_label_marked') || '我关注的任务',
          badge: this.total.marked,
          type: 'warning',
          icon: 'el-icon-star-off',
          value: 'marked',
        },
      ]
    },
  },
  methods: {
    change({ value }) {
      this.$emit('change', value)
      this.$emit('input', value)
      this.$emit('update:value', value)
    },
    async getData(form = {}) {
      const res = await this.$api
        .personalTskInfoTotalApi(form)
        .catch(() => ({}))
      this.total = res.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-button {
    width: 100%;
  }
}
.filter-list {
  .filter-item_wrapper {
    margin-bottom: 15px;
  }
  .filter-item_wrapper:first-child {
    margin-top: 20px;
    .filter-item_divided {
      display: none !important;
    }
  }
  .filter-item_wrapper:last-child {
    margin-bottom: 13px;
  }
  .filter-item_wrapper.activate {
    .filter-item {
      background-color: #f8f8f8;
      .filter-item_icon {
        color: #007bff;
      }
      .filter-item_label {
        color: #007bff;
      }
    }
  }
  .filter-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    .filter-item_icon {
      color: #bbbbbb;
      width: 24px;
      height: 24px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .filter-item_label {
      font-size: 14px;
      line-height: 24px;
      color: #101010;
      font-weight: 500;
    }

    .filter-item_badge {
      --f-color: #ffffff;
      --bg-color: #8e8e8e;
      font-size: 11px;
      color: var(--f-color);
      min-width: 24px;
      max-width: 48px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--bg-color);
      border-radius: 5px;
    }
    .filter-item_badge.filter-item_badge_warning {
      --bg-color: #e99d42;
    }
    .filter-item_badge.filter-item_badge_danger {
      --bg-color: #fa5c7c;
    }
    .filter-item_badge.filter-item_badge_success {
      --bg-color: #34cc5f;
    }
    .filter-item_badge.filter-item_badge_primary {
      --bg-color: #007bff;
    }
    .filter-item_badge.filter-item_badge_secondary {
      --bg-color: #d1e6ff;
      --f-color: #6c757d;
    }
  }
  .filter-item:hover {
    background-color: #f8f8f8;
    .filter-item_icon {
      color: #007bff;
    }
    .filter-item_label {
      color: #007bff;
    }
  }
  .filter-item_divided {
    height: 1px;
    background-color: #dfe3ea;
    margin-bottom: 15px;
    margin: 0 10px 15px;
  }
}
</style>
